let $ = window.jQuery


function css(a, $) {
    // console.log(a)
    // var elements = $jQuery("*", a)
    var sheets = document.styleSheets, o = {};
    // jQuery.each(function(){
    //   for (var i in sheets) {
    //     var rules = sheets[i].rules || sheets[i].cssRules;
    //     for (var r in rules) {
    //         if ((!!!o[rules[r].selectorText]) && this.is(rules[r].selectorText)) {
    //             o = $.extend(o, css2json(rules[r].style), css2json(a.attr('style')));
    //         }
    //     }
    //   }
    // })

    
    for (var i in sheets) {
        var rules = sheets[i].rules || sheets[i].cssRules;
        for (var r in rules) {
            if (a.is(rules[r].selectorText)) {
                o = $.extend(o, css2json(rules[r].style), css2json(a.attr('style')));
            }
        }
    }
    return o;
}

function css2json(css) {
    var s = {};
    if (!css) return s;
    if (css instanceof CSSStyleDeclaration) {
        for (var i in css) {
            if ((css[i]).toLowerCase) {
                s[(css[i]).toLowerCase()] = (css[css[i]]);
            }
        }
    } else if (typeof css == "string") {
        css = css.split("; ");
        for (var i in css) {
            var l = css[i].split(": ");
            s[l[0].toLowerCase()] = (l[1]);
        }
    }
    return s;
}

const  getAllCssRules = css;
export default getAllCssRules;